/*
 * @Author: Json Chen
 * @Date: 2021-06-30 11:26:23
 * @LastEditTime: 2022-06-13 13:28:38
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelLanguage/Components/AvailableLanguagesModalForm.tsx
 */

import SelectObjectAsValue from '@/src/components/SelectObjectAsValue';
import useResetFormOnCloseModal from '@/src/hooks/useResetFormOnCloseModal';
import { Form, Modal } from 'antd';
import React from 'react';
import styles from '../style.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const PriceTierModalForm = ({
  visible,
  onCancel,
  onModalConfirm,
  availableLanguages,
  languageOptionsList,
}: {
  // 弹窗是否展示
  visible: boolean;
  // 关闭弹窗
  onCancel: () => void;
  onModalConfirm: (data: any) => void;
  availableLanguages: any[];
  languageOptionsList: any[];
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [form] = Form.useForm();
  useResetFormOnCloseModal({
    form,
    visible,
  });

  const getOptions = ({ languageOptionsList, availableLanguages }) => {
    return languageOptionsList
      .filter((o) => {
        return !availableLanguages.some((a) => a.tag === o.languageTag);
      })
      .map((o) => ({
        ...o,
        label: o.description,
        value: o.languageTag,
      }));
  };

  const options = getOptions({ languageOptionsList, availableLanguages });

  const onOk = () => {
    form.validateFields().then((res) => {
      const { locale } = res;
      onModalConfirm(locale);
    });
  };

  return (
    <Modal
      forceRender={true}
      title={getI18n('salesChannelLanguage.index.addNewAvailableLanguage')}
      visible={visible}
      okText={getI18n('general.confirm')}
      cancelText={getI18n('general.cancel')}
      maskClosable={false}
      width={600}
      wrapClassName={styles.modalContainer}
      onOk={onOk}
      onCancel={onCancel}>
      <Form
        form={form}
        layout='vertical'
        name='availableLanguagesModalForm'
        className={styles.availableLanguagesModalForm}>
        <div className={styles.text}>
          {getI18n('salesChannelLanguage.index.availableLanguagesModalFormtip')}
        </div>
        <Form.Item
          name='locale'
          className={styles.select}
          label={
            <div className={styles.selectLabel}>
              <div className={styles.selectLabelTitle}>
                {getI18n('salesChannelLanguage.index.selectLanguage')}
              </div>
            </div>
          }
          rules={[{ required: true }]}>
          <SelectObjectAsValue objectAsValue options={options} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default PriceTierModalForm;
